/** @file Provides a simple, native toast library for Modal. */

import type { SvelteComponent } from "svelte";
import { toast } from "svelte-sonner";
import { v4 as uuidv4 } from "uuid";

import { normalizeError } from "./error";
import { default as ToastComponent } from "./ui/system/Toast.svelte";

export type Toast = {
  kind: "info" | "success" | "error";
  message: string;
  link?: { name: string; href: string };
};

export function makeToast(t: Toast, duration: number = 3000) {
  const id = uuidv4();
  toast(ToastComponent as typeof SvelteComponent, {
    id,
    duration,
    unstyled: true,
    componentProps: {
      id,
      kind: t.kind,
      message: t.message,
      link: t.link,
    },
  });
}

export async function makeErrorToast(error: Error) {
  makeToast(
    {
      kind: "error",
      message: await normalizeError(error),
    },
    5000,
  );
}
